
import { DataUtilitiesClass } from "@dndUtilities/data_utilities_class";

const DataUtilities = (function () {
  let instance: DataUtilitiesClass;

  function createInstance() {
    const util = new DataUtilitiesClass();
    return util;
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    }
  };
})();

export default DataUtilities;
